<template>
<div class="list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div v-if="optedOut" class="controls">You are currently opted out of Promo Packs!</div>
		<div v-else-if="showDetail" class="controls">
			<div v-if="detail.purchase_order_id" :class="['button', optedOut ? 'disabled' : 'neutral']" @click="goToPO()">Manage Purchase Order</div>
			<div v-else :class="['button', saving || optedOut ? 'disabled' : 'neutral']" @click="addToPurchaseOrder('all')">Add All Items to a Purchase Order</div>
		</div>
	</div>

	<div class="filters">
		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>
		<div :class="['button', hasFilters ? 'neutral' : 'disabled']" @click="clearFilters()">Clear Filters</div>
		<div v-if="showDetail" class="button neutral" @click="showDetail = false">Back to List</div>
		<div class="divider"></div>
		<div class="extra-menu-item" @click="showAbout = !showAbout">About Promo Packs</div>
		<div class="extra-menu-item" @click="showOptOut = !showOptOut">Opt {{ optedOut ? 'In' : 'Out' }}</div>
	</div>

    <div v-if="!showDetail" class="list report-list">

		<loading v-if="loading" class="loading"></loading>

		<div class="list-detail" style="padding: 0 0 0 1em;">
			<h1 style="margin: 0 0 0.25em 0;">Available Promo Packs</h1>

			<div v-if="availablePushPacks().length > 0" class="promo-pack-available">

				<div class="promo-pack-tile-list" v-for="(pushPack, index) in availablePushPacks()">
					<div class="promo-pack-logo">
						<img v-if="pushPack.source_code == 'RSR'" src="@/assets/img/logo-rsr.jpg" />
						<img v-if="pushPack.source_code == 'SS'" src="@/assets/img/logo-sportssouth.jpg" />
						<div v-if="!pushPack.account_number" style="text-align: center; font-size: 0.9em; font-weight: bold;">No Account!</div>
					</div>
					<div class="promo-pack-tile-list-data">
						<div class="description">{{ pushPack.description}}</div>
						<div class="data-wrapper">
							<div class="data">
								<label>Marquees</label>{{ pushPack.marquees }}<br>
								<label>Feature Products</label>{{ pushPack.products }}<br>
							</div>
						</div>
					</div>
					<div>
						<label>Order Start</labeL>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.order_start_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.order_start_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.order_start_date).format('dddd') }}</div>
						</div>
					</div>
					<div>
						<label>Order End</labeL>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.order_end_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.order_end_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.order_end_date).format('dddd') }}</div>
						</div>
					</div>
					<div></div>
					<div>
						<label>Public Start</label>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.start_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.start_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.start_date).format('dddd') }}</div>
						</div>
					</div>
					<div>
						<label>Public End</label>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.end_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.end_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.end_date).format('dddd') }}</div>
						</div>
					</div>
					<div></div>
					<div class="data-controls">
						<div class="button neutral" @click="getDetail(pushPack)">Details</div>
						<div :class="['button', canActivate(pushPack) ? 'action' : 'disabled']" @click="confirmActivate(pushPack)">Activate</div>
					</div>
					<div></div>
					<div v-if="pushPack.email.schedule_date" class="email-alert" @click="doShowEmailAlert(pushPack)">
						<label>Email <i class="fa fa-info-circle"></i></label>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.email.schedule_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.email.schedule_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.email.schedule_date).format('dddd') }}</div>
						</div>
					</div>
					<div v-else></div>
				</div>
			</div>

			<div v-else class="empty-list">There are no available promo packs</div>

			<h1 style="margin: 0 0 0.25em 0;">Activated Promo Packs</h1>

			<div v-if="activePushPacks().length > 0">
				<div class="promo-pack-tile-list" v-for="(pushPack, index) in activePushPacks()">
					<div class="promo-pack-logo">
						<img v-if="pushPack.source_code == 'RSR'" src="@/assets/img/logo-rsr.jpg" />
						<img v-if="pushPack.source_code == 'SS'" src="@/assets/img/logo-sportssouth.jpg" />
						<div v-if="!pushPack.account_number" style="text-align: center; font-size: 0.9em; font-weight: bold;">No Account!</div>
					</div>
					<div class="promo-pack-tile-list-data">
						<div class="description">{{ pushPack.description }}</div>
						<div class="data-wrapper">
							<div class="data">
								<label>Marquees</label>{{ pushPack.marquees }}<br>
								<label>Feature Products</label>{{ pushPack.products }}<br>
							</div>
						</div>
					</div>
					<div>
						<label>Order Start</labeL>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.order_start_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.order_start_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.order_start_date).format('dddd') }}</div>
						</div>
					</div>
					<div>
						<label>Order End</labeL>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.order_end_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.order_end_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.order_end_date).format('dddd') }}</div>
						</div>
					</div>
					<div></div>
					<div>
						<label>Public Start</label>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.start_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.start_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.start_date).format('dddd') }}</div>
						</div>
					</div>
					<div>
						<label>Public End</label>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.end_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.end_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.end_date).format('dddd') }}</div>
						</div>
					</div>
					<div></div>
					<div class="data-controls">
						<div class="button neutral" @click="getDetail(pushPack)">Details</div>
						<div :class="['button', canActivate(pushPack) ? 'action' : 'disabled']" @click="confirmActivate(pushPack)">Deactivate</div>
					</div>
					<div></div>
					<div v-if="pushPack.email.schedule_date" class="email-alert" @click="doShowEmailAlert(pushPack)">
						<label>Email <i class="fa fa-info-circle"></i></label>
						<div class="promo-pack-calendar-icon">
							<div class="month">{{ $moment(pushPack.email.schedule_date).format('MMM').toUpperCase() }}</div>
							<div class="day">{{ $moment(pushPack.email.schedule_date).format('D') }}</div>
							<div class="weekday">{{ $moment(pushPack.email.schedule_date).format('dddd') }}</div>
						</div>
					</div>
					<div v-else></div>
				</div>
			</div>
			<div v-else class="empty-list">You have no activated promo packs</div>
		</div>

	</div>

	<div v-if="showDetail" class="detail promo-detail">
		<h1 style="margin: 0 0 0.25em 0;">Promo Pack Details</h1>

		<div class="promo-pack-tile-list">
			<div class="promo-pack-logo">
				<img v-if="detail.source_code == 'RSR'" src="@/assets/img/logo-rsr.jpg" />
				<img v-if="detail.source_code == 'SS'" src="@/assets/img/logo-sportssouth.jpg" />
				<div v-if="!detail.account_number" style="text-align: center; font-size: 0.9em; font-weight: bold;">No Account!</div>
			</div>
			<div class="promo-pack-tile-list-data">
				<div class="description">{{ detail.description}}</div>
				<div class="data-wrapper">
					<div class="data">
						<label>Marquees</label>{{ detail.marquees }}<br>
						<label>Feature Products</label>{{ detail.products }}<br>
					</div>
				</div>
			</div>
			<div>
				<label>Order Start</labeL>
				<div class="promo-pack-calendar-icon">
					<div class="month">{{ $moment(detail.order_start_date).format('MMM').toUpperCase() }}</div>
					<div class="day">{{ $moment(detail.order_start_date).format('D') }}</div>
					<div class="weekday">{{ $moment(detail.order_start_date).format('dddd') }}</div>
				</div>
			</div>
			<div>
				<label>Order End</labeL>
				<div class="promo-pack-calendar-icon">
					<div class="month">{{ $moment(detail.order_end_date).format('MMM').toUpperCase() }}</div>
					<div class="day">{{ $moment(detail.order_end_date).format('D') }}</div>
					<div class="weekday">{{ $moment(detail.order_end_date).format('dddd') }}</div>
				</div>
			</div>
			<div></div>
			<div>
				<label>Public Start</label>
				<div class="promo-pack-calendar-icon">
					<div class="month">{{ $moment(detail.start_date).format('MMM').toUpperCase() }}</div>
					<div class="day">{{ $moment(detail.start_date).format('D') }}</div>
					<div class="weekday">{{ $moment(detail.start_date).format('dddd') }}</div>
				</div>
			</div>
			<div>
				<label>Public End</label>
				<div class="promo-pack-calendar-icon">
					<div class="month">{{ $moment(detail.end_date).format('MMM').toUpperCase() }}</div>
					<div class="day">{{ $moment(detail.end_date).format('D') }}</div>
					<div class="weekday">{{ $moment(detail.end_date).format('dddd') }}</div>
				</div>
			</div>
			<div></div>
			<div class="data-controls">
				<div :class="['button', canActivate(detail) ? 'action' : 'disabled']" @click="confirmActivate(detail)">{{ detail.active ? "Deactivate" : "Activate" }}</div>
			</div>
			<div></div>
			<div v-if="detail.email.schedule_date" class="email-alert" @click="doShowEmailAlert(detail)">
				<label>Email <i class="fa fa-info-circle"></i></label>
				<div class="promo-pack-calendar-icon">
					<div class="month">{{ $moment(detail.email.schedule_date).format('MMM').toUpperCase() }}</div>
					<div class="day">{{ $moment(detail.email.schedule_date).format('D') }}</div>
					<div class="weekday">{{ $moment(detail.email.schedule_date).format('dddd') }}</div>
				</div>
			</div>
			<div v-else></div>
		</div>

        <div class="form-section">
            <h2 class="promo-section-heading">Marquees</h2>
            <div v-if="marquees.length == 0" class="empty-list center">No marquees</div>

            <div v-else v-for="(marquee, index) in marquees" :key="index" class="marquee-grid">
                <img :src="marquee.image_src">
                <div class="caption">
					<div><b>{{ marquee.description }}</b></div>
					<div><label>UPC</label> <b>{{ marquee.upc }}</b></div>
					<div><label>{{ detail.source_code }}#</label> <b>{{ marquee.item_number }}</b></div>
				</div>
				<div class="caption prices">
					<label></label>
					<label>Cost</label>
					<label>Price</label>
					<label>Margin</label>
					<label>Regular</label>
					<span>${{ formatCurrency(marquee.regular_cost) }}</span>
					<span>${{ formatCurrency(marquee.regular_price) }}</span>
					<span>{{ getMargin(marquee.regular_cost, marquee.regular_price) }}</span>
					<label>Promo</label>
					<span>${{ formatCurrency(marquee.cost) }}</span>
					<span>${{ formatCurrency(marquee.price) }}</span>
					<span>{{ getMargin(marquee.cost, marquee.price) }}</span>
				</div>
				<div style="padding: 1em 0 0 0;">
					<div class="button neutral smaller" @click="setOverride(marquee)"><i class="fa fa-dollar-sign" /></div>
				</div>
				<div class="promo-tile-controls">
					<div>
						<label>In PO</label> <b>{{ marquee.in_purchase_order }}</b>
						<label>On Hand</label> <b>{{ marquee.stock.quantity || 0 }}</b>
						<label>On Order</label> <b>{{ marquee.stock.ordered - marquee.stock.received }}</b>
					</div>
					<label>Qty</label> <input type="number" v-model="marquee.add_quantity" :disabled="detail.purchase_order_id && detail.purchase_order_status_code != 'DRAFT'">
					<button v-if="marquee.in_purchase_order && detail.purchase_order_status_code != 'DRAFT'" :class="['button', optedOut ? 'disabled' : 'neutral']" @click="goToPO()" title="Only DRAFT status can have items added">PO Status {{ detail.purchase_order_status_code }}</button>
					<button v-else :class="['button', marquee.saving || optedOut ? 'disabled' : 'neutral']" @click="addToPurchaseOrder(marquee)">Add {{ marquee.add_quantity }} To PO</button>
				</div>
            </div>

        </div>

        <div class="form-section">
            <h2 class="promo-section-heading">Featured Products</h2>
            <div v-if="products.length == 0" class="empty-list center">No featured products</div>

            <div v-else v-for="(product, index) in products" :key="index" class="product-grid">
                <div style="text-align: center; position: relative;">
					<img v-if="product.display_flag > 0" v-bind:src="require('@/assets/img/sale-badge-' + product.display_flag + '.png')" class="display-flag">
                    <img :src="product.image_src" class="product-image" style="width: auto;">
                </div>
                <div class="caption">
					<div><b>{{ product.description }}</b></div>
					<div><label>UPC</label> <b>{{ product.upc }}</b></div>
					<div><label>{{ detail.source_code }}#</label> <b>{{ product.item_number }}</b></div>
				</div>
				<div class="caption prices">
					<label></label>
					<label>Cost</label>
					<label>Price</label>
					<label>Margin</label>
					<label>Regular</label>
					<span>${{ formatCurrency(product.regular_cost) }}</span>
					<span>${{ formatCurrency(product.regular_price) }}</span>
					<span>{{ getMargin(product.regular_cost, product.regular_price) }}</span>
					<label>Promo</label>
					<span>${{ formatCurrency(product.cost) }}</span>
					<span>${{ formatCurrency(product.price) }}</span>
					<span>{{ getMargin(product.cost, product.price) }}</span>
				</div>
				<div style="padding: 1em 0 0 0;">
					<div class="button neutral smaller" @click="setOverride(product)"><i class="fa fa-dollar-sign" /></div>
				</div>
				<div class="promo-tile-controls">
					<div>
						<label>In PO</label> <b>{{ product.in_purchase_order }}</b>
						<label>On Hand</label> <b>{{ product.stock.quantity || 0 }}</b>
						<label>On Order</label> <b>{{ product.stock.ordered - product.stock.received }}</b>
					</div>
					<label>Qty</label> <input type="number" v-model="product.add_quantity" :disabled="detail.purchase_order_id && detail.purchase_order_status_code != 'DRAFT'">
					<button v-if="product.in_purchase_order && detail.purchase_order_status_code != 'DRAFT'" :class="['button', optedOut ? 'disabled' : 'action']" @click="goToPO()" title="Only DRAFT status can have items added">PO Status {{ detail.purchase_order_status_code }}</button>
					<button v-else :class="['button', product.saving || optedOut ? 'disabled' : 'neutral']" @click="addToPurchaseOrder(product)">Add {{ product.add_quantity }} To PO</button>
				</div>
            </div>

        </div>

        <div class="form-section two-columns">
			<div v-if="detail.email.schedule_date">
	            <h2 class="promo-section-heading">Email Blast</h2>
				<div class="email-section">
					<div class="iframe-wrap">
						<iframe :src="email.email_preview" />
					</div>
					<div class="email-section-details">
						<h3>About Promo Pack Emails</h3>
						<p>All promo pack emails are automatically sent to your customer list on the date the promotion goes public. Everything in the email links directly to your website at <b>{{ clientDomain }}</b>, including the Buy Now buttons.</p>
						<div v-if="!canActivate(detail)">
							<p><b>NOTE:</b> automatic email is not available because this Promo Pack cannot be activated.</p>
							<div class="button neutral" @click="confirmActivate(detail)">Why not?</div>
						</div>
						<div v-else>
							<p v-if="emailLog.sent">This email was sent on {{ emailLog.schedule_time }}</p>
							<p v-else>This email is scheduled to be sent on <b>{{ $moment(email.schedule_date).format('MM/DD/YY') }}</b></p>
						</div>
					</div>
				</div>
			</div>
			<div v-if="hasFlyer">
	            <h2 class="promo-section-heading">In-Store Flyer</h2>
				<div class="email-section">
					<div class="iframe-wrap">
						<iframe :src="email.flyer_preview" />
					</div>
					<div class="email-section-details">
						<h3>About In-Store Flyers</h3>
						<p>You can download a PDF that features the items in this promo pack with prices and bar codes for easy scanning at your point of sale. The PDF can be printed as a single page.</p>
						<div v-if="!canActivate(detail)">
							<p><b>NOTE:</b> in-store flyer download is not available because this Promo Pack cannot be activated.</p>
							<div class="button neutral" @click="confirmActivate(detail)">Why not?</div>
						</div>
						<div v-else>
							<p>Here's the link to generate and download your in-store flyer...</p>
							<a :href="flyerLink()" target="_blank">{{ detail.push_pack_code.toLowerCase() }}_flyer.pdf</a>
						</div>
					</div>
				</div>
			</div>
        </div>

	</div>

	<div class="modal" v-if="showConfirm">
		<div class="inner">
			<h2>{{ confirmActivateDetails.active ? 'Deactivate' : 'Activate' }} Promo Pack</h2>
			<div class="content">
				<p>You are about to {{ confirmActivateDetails.active ? 'deactivate' : 'activate' }} the <b>{{ confirmActivateDetails.company_name }} &rang; {{ confirmActivateDetails.description }}</b> promo pack.</p>
				<p>This will {{ confirmActivateDetails.active ? 'remove' : 'add' }} the promo pack's
					<b>{{ confirmActivateDetails.marquees }} marquee{{ confirmActivateDetails.marquees == 1 ? '' : 's' }}</b>
					and <b>{{ confirmActivateDetails.products }} featured product{{ confirmActivateDetails.marquees == 1 ? '' : 's' }}</b>
					{{ confirmActivateDetails.active ? 'from' : 'to' }} your website<span v-if="$moment().isBefore(confirmActivateDetails.start_date)"> on <b>{{ $moment(confirmActivateDetails.start_date).format('MM/DD/YY') }}</b>, the date the promotion goes public</span>.</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showConfirm = false">Cancel</div>
				<div :class="['button', 'spaced', saving ? 'disabled' : 'action']" @click="activatePromoPack()">{{ confirmActivateDetails.active ? 'Deactivate' : 'Activate' }}</div>
                <div class="note" v-if="confirmMessage">{{ confirmMessage }}</div>
			</div>
		</div>
	</div>

	<div class="modal about-promo-packs" v-if="showAbout">
		<div class="inner">
			<h2>About Promo Packs</h2>
			<div class="content">
				<p>Promo Packs are custom groups of products offered for a limited-time through the buying power of our top national distributor partners.</p>

				<h3>Order Start / Order End</h3>
				<p>Both pricing and availability are guaranteed during the promotional period. This means you don't need to have items on hand for the "buy now" email that automatically goes out to your customers on your behalf. But we do recommend that you pre-order product to boost your in-store sales as well.</p>

				<h3>Public Start / Public End</h3>
				<p>Promo packs are available to the public for a limited time only. After the Public End date, distributor availability and speical pricing are no longer guaranteed.</p>

				<h3>Activate / Deactivate</h3>
				<p>You can activate or deactivate any Promo Pack during its public dates. Marquees and Featured Products are automatically added to your front-end website when a Promo Pack is activated.</p>

				<h3>Email</h3>
				<p>If a Promo Pack includes an Email, your customers will automaticaly receive a "Shop Now" email that links back to your website. Emails are professionally designed by our marketing team to generate high click-rates and complete online purchases. And the best part is you don't need to do anyting to generate these sales.</p>

				<h3>In-store Flyers</h3>
				<p>The in-store flyer is also professionally designed as a convenience to you. Download and print as many as you need at any time to help boost your in-store sales of promotional items.</p>

			</div>
			<div class="controls">
				<div class="button cancel" @click="showAbout = false">Got It</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showOptOut">
		<div class="inner">
			<h2>Opt {{ optedOut ? 'In To' : 'Out Of' }} Promo Packs</h2>
			<div v-if="optedOut" class="content">
				<p>You previously opted out of Promo Packs...</p>
				<p class="indent">{{ optedOut }}</p>
				<p>Click the Opt In button below to give you full access to the buying power of our top national distributor partners.</p>
			</div>
			<div v-else class="content">
				<p>Promo Packs are an easy way for you to leverage the buying power of our top national distributor partners to increase your store's sales.</p>
				<p>However, we understand if you don't want to participate. Please comment on why you are opting out of Promo Packs, then click the Opt Out button.</p>
				<label>Why are you opting out?</label>
				<textarea v-model="optOutReason" placeholder="Comment..."></textarea>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showOptOut = false">Cancel</div>
				<div v-if="optedOut" class="button action" @click="doOptOut()">Opt In</div>
				<div v-else :class="['button', optOutReason ? 'action' : 'disabled']" @click="doOptOut()">Opt Out</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showEmailAlert">
		<div class="inner">
			<h2>Promo Pack Email</h2>
			<div class="content">
				<p>The <b>{{ emailAlert.description }}</b> promo pack includes an email scheduled on <b>{{ $moment(emailAlert.email.schedule_date).format('M/D/Y') }}</b>.</p>
				<p>Your customers {{ optedOut ? 'would' : 'will' }} automaticaly receive a "Shop Now" email with products that link directly back to your website. The email {{ optedOut ? 'would' : 'will' }} be sent whether this promo pack has been activated or not.</p>
				<p v-if="optedOut">You can <b @click="showEmailAlert = false; showOptOut = !showOptOut">Opt In</b> if you want to participate in Promo Pack emails.</p>
				<p v-else>You can <b @click="showEmailAlert = false; showOptOut = !showOptOut">Opt Out</b> if you don't want to participate in Promo Pack emails.</p>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showEmailAlert = false">Got It</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showCannotActivate">
		<div class="inner">
			<h2>You cannot activate this promo pack</h2>
			<div class="content">
				<p>{{ cannotActivateMessage }}</p>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showCannotActivate = false">Got It</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<price-override-detail v-if="showPriceOverride" :listDetail="priceOverride" @backToList="finishedPriceOverride" />

	<help-popup :helpLink="{177:'Distributor Promo Packs', 178:'Promo Pack Marquees', 179:'Promo Pack Featured Products', 180:'Promo Pack Email Blast', 369:'Promo Pack Price Overrides'}" :tours="false"></help-popup>

</div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import PriceOverrideDetail from '@/components/PriceOverrideDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
    components: {
        'loading': Loading,
		'price-override-detail': PriceOverrideDetail,
		'help-popup': HelpPopup
	},
    data() {
        return {
            loading: false,
			filters: {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: ''
			},
			message: '',
			messageStatus: '',
			messageTimeout: 0,
            clientId: '',
            pushPacks: [],
            push_pack_id: '',
            detail: {},
			hasFlyer: false,
			confirmActivateDetails: {},
            purchase_order_id: '',
            purchase_order_status_code: '',
            marquees: [],
            marqueePrices: {},
            products: [],
            productPrices: {},
            email: {},
			emailLog: {},
			clientDomain: '',
            distributorCode: '',
            distributorId: '',
            showDetail: false,
            displayFlags: {
                0: {'label': '', 'color': "#fff;"},
                1: {'label': 'Sale', 'color': "#C71D22;"},
                2: {'label': 'Temporary Price Reduction', 'color': "#F8B100;"},
                3: {'label': 'Temporary Lower Cost', 'color': "#00CE22;"},
                4: {'label': 'Free Shipping', 'color': "#0061E0;"},
                5: {'label': 'Shop In-Store For Lowest Prices', 'color': "#DF8605;"},
                6: {'label': 'Closeout', 'color': "#27C344;"}
            },
			showConfirm: false,
			confirmMessage: '',
        	saving: false,
			doNotEmail: false,
			showAbout: false,
			showOptOut: false,
			optOutReason: '',
			optedOut: false,
			emailAlert: {},
			showEmailAlert: false,
			showCannotActivate: false,
			cannotActivateMessage: '',
			showPriceOverride: false,
			priceOverride: {}
        }
    },
    created() {
        this.getList()
    },
    computed: {
		hasFilters() {
			return this.filters.search_term || this.filters.start_date || this.filters.end_date
		}
    },
    methods: {
		pushPacksByCode(code) {
			return this.pushPacks.filter(item => item.source_code == code && !item.active)
		},
		activePushPacks() {
			return this.pushPacks.filter(item => item.active)
		},
		availablePushPacks() {
			return this.pushPacks.filter(item => item.active == '')
		},
        getList() {
			if (this.loading) { return }
			this.showDetail = false
			this.showConfirm = false
            this.detail = {}
			this.marquees = []
			this.marqueePrices = {}
			this.products = []
			this.productPrices = {}
			this.email = {}
			this.emailLog = {}
			this.message = ''
			this.saving = false
			this.loading = true
			this.message = 'Loading promo packs...'
			this.messageStatus = 'waiting'
            this.apiCall({ destination: 'get_list_push_packs', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				this.message = ''
                this.clientId = obj.client_id
				this.pushPacks = obj.push_packs
				this.optedOut = obj.opted_out
			}).catch(err => {
				console.log(err)
			})
        },
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: ''
			}
			this.getList()
		},
		getDetail(pushPack) {
			this.detail = pushPack
			this.showDetail = true
			this.apiCall({ destination: 'get_list_push_pack_marquees', data: { push_pack_id: this.detail.push_pack_id, distributor_id: this.detail.distributor_id }}).then(obj => {
				this.marquees = obj.marquees
				this.marqueePrices = obj.marquee_prices
			})
			this.apiCall({ destination: 'get_list_push_pack_products', data: { push_pack_id: this.detail.push_pack_id, distributor_id: this.detail.distributor_id }}).then(obj => {
				this.products = obj.products
				this.productPrices = obj.product_prices
			})
			this.apiCall({ destination: 'get_item_push_pack_email', data: { push_pack_id: this.detail.push_pack_id, distributor_id: this.detail.distributor_id }}).then(obj => {
				this.clientDomain = obj.client_domain
				this.email = obj.email
			})
		},
		getMargin(cost, price) {
			if (cost > 0 && price > 0) {
				return (100 * (1 - (Number(cost) / Number(price)))).toFixed(1) + '%'
			} else {
				return ''
			}
		},
		setOverride(product) {
			this.priceOverride = product
			this.showPriceOverride = true
		},
		finishedPriceOverride(updateRequired) {
			if (updateRequired) {
				this.getDetail(this.detail)
			}
			this.showPriceOverride = false
		},
		formatCurrency(value) {
			return value ? Number(value).toFixed(2) : '0.00'
		},
		addToPurchaseOrder(item) {
			if (this.saving || item.saving || this.optedOut) { return }
			let postData = {
				push_pack_id: this.detail.push_pack_id,
				distributor_id: this.detail.distributor_id,
				product_ids: []
			}
			if (item == 'all') {
				this.saving = true
				for (var i = 0; i < this.marquees.length; i++) {
					postData.product_ids.push({ product_id: this.marquees[i].product_id, quantity: this.marquees[i].add_quantity })
				}
				for (var i = 0; i < this.products.length; i++) {
					postData.product_ids.push({ product_id: this.products[i].product_id, quantity: this.products[i].add_quantity })
				}
			} else {
				postData.product_ids.push({ product_id: item.product_id, quantity: item.add_quantity })
				item.saving = true
			}
			this.apiCall({ destination: 'add_to_purchase_order', data: postData }).then(obj => {
				if (obj.status == 'success') {
					if (item == 'all') {
						this.saving = false
						this.getDetail(this.detail.push_pack_id)
					} else {
						item.purchase_order_id = obj.purchase_order_id
						item.in_purchase_order += parseInt(item.add_quantity)
						this.detail.purchase_order_id = obj.purchase_order_id
						this.detail.purchase_order_status_code = obj.purchase_order_status_code
						item.saving = false
					}
				} else {
					console.log(obj.message)
				}
			})
		},
		goToPO() {
			if (this.optedOut) { return }
			if (this.detail.purchase_order_id) {
				this.$router.push("/legacy/purchaseordermaintenance.php?purchase_order_id=" + this.detail.purchase_order_id)
			}
		},
		canActivate(details) {
			return details.account_number && !details.excluded && !this.optedOut
		},
		confirmActivate(details) {
			if (!this.canActivate(details)) {
				if (!details.account_number) {
					this.cannotActivateMessage = "You don't have a " + details.company_name + " account number set up in your Distributor Preferences."
				}
				if (details.excluded) {
					this.cannotActivateMessage = "Your store location is not eligible for this promo pack."
				}
				if (this.optedOut) {
					this.cannotActivateMessage = "You have opted out of promo packs."
				}
				this.showCannotActivate = true
				return
			}
			this.confirmActivateDetails = details
			this.showConfirm = true
		},
		activatePromoPack() {
			if (this.saving) { return}
			this.saving = true
			this.apiCall({ destination: 'activate_push_pack', data: { push_pack_id: this.confirmActivateDetails.push_pack_id, deactivate: this.confirmActivateDetails.active, do_not_email: this.doNotEmail }}).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.message = obj.message
					this.detail.active = !this.detail.active
					window.setTimeout(() => this.message = this.detail.active ? '' : 'Promo prices available when active', 1500);
					this.getList()
				} else {
					this.message = obj.message
				}
			})
		},
		emailLink() {
			if (window.location.hostname.indexOf('.test') > -1) {
				return 'https://cds.test/promopacks/' + this.detail.push_pack_code.toLowerCase() + '_email.php'
			} else {
				return window.location.protocol + '//' + window.location.hostname + '/promopacks/' + this.detail.push_pack_code.toLowerCase() + '_email.php'
			}
		},
		flyerLink() {
			if (window.location.hostname.indexOf('.test') > -1) {
				return 'https://cds.test/promopacks/flyer_to_pdf.php?filename=' + this.detail.push_pack_code.toLowerCase() + '_flyer'
			} else {
				return window.location.protocol + '//' + window.location.hostname + '/promopacks/flyer_to_pdf.php?filename=' + this.detail.push_pack_code.toLowerCase() + '_flyer'
			}
		},
		doOptOut() {
			if (this.saving) { return}
			this.saving = true
			this.apiCall({ destination: 'save_opt_out_push_packs', data: { opt_out_reason: this.optOutReason }}).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.showOptOut = false
					this.optOutReason = ''
					this.getList()
				} else {
					this.message = obj.message
				}
			})
		},
		doShowEmailAlert(pushPack) {
			this.emailAlert = pushPack
			this.showEmailAlert = true
		}
    }
}
</script>

<style lang="scss" scoped>
.promo-pack-available {
	border-bottom: 1px solid #000;
	margin: 0 0 1em 0;
}
.promo-pack-tile-heading {
	text-align: center;
	img { max-height: 5em; }
	margin: 0 0 1em 0;
}
.promo-pack-tile-list {
	display: grid;
	grid-template-columns: 7em 1fr 5em 5em 1em 5em 5em 1em 10em 1em 5em;
	grid-column-gap: 0.5em;
	align-items: center;
	label { font-size: 0.8em; text-align: center; display: block; }
	margin: 0 0 1em 0;
	padding: 0.5em 0 0 0;
	border-top: 1px solid #ccc;
	img { max-width: 100%; }
	.promo-pack-calendar-icon {
		border: 1px solid #ccc;
		border-radius: 12px;
		text-align: center;
		font-size: 0.8em;
		.month {
			background-color: #999; // #ecaa37;
			color: #ffffff;
			border-top-left-radius: 12px;
			border-top-right-radius: 12px;
			padding: 0.5em 0 0.25em 0;
			margin: 0 0 0.25em 0;
		}
		.day {
			font-size: 1.5em;
			font-weight: bold;
		}
		.weekday {
			color: #999; // #ecaa37;
			font-size: 0.8em;
			padding: 0 0 0.5em 0;
		}
	}
	.promo-pack-tile-list-data {
		padding: 0.5em 0 0 1em;
		.description {
			font-weight: bold;
			margin: 0 0 0.5em 0;
		}
		.data-wrapper {
			// display: grid;
			// grid-template-columns: 1fr 1.5fr;
			// align-items: center;
			// margin: 0 1em 0 0;
		}
		.data {
			font-size: 0.9em;
			label { display: inline-block; padding: 0 1em 0 0; }
		}
	}
	.data-controls {
		.button { display: block; margin: 0 0 0.5em 0; }
		.button:last-of-type { margin: 0 0 0 0; }
	}
	.email-alert {
		cursor: pointer;
	}
}
.promo-detail {
	margin: 0 0 0 1em;
}
.promo-detail-meta {
	margin: 1em;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
}
.promo-section-heading {
	margin: 1em 0 0.5em 0;
}

.promo-tile-controls {
	text-align: right;
	label { margin: 0 0 0 1em; }
	label:first-of-type { margin: 0; }
	input { font-size: 0.9em; width: 4em; margin: 0.5em 1em 0 0; }
	button { font-size: 0.7em; width: 12em; }
}

.marquee-grid, .product-grid {
    position: relative;
    background-color: #fff;
    display: grid;
	grid-template-columns: 12em 1.33fr 1fr 1.5em 1fr;
	grid-gap: 1em;
	align-items: start;
	margin: 0 0 0.5em 0;
	padding: 0 0 0.5em 0;
	border-bottom: 1px solid #ccc;
	img { width: auto; max-width: 100%; max-height: 3.5em; }
	label { color: #666; }
	.prices {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}
}

.list-detail img { width: auto; }
.marquee-grid img { width: 100%; }
.product-image { max-height: 9em; max-width: 90%; }
.display-flag {
    height: 9em;
    position: absolute;
    top: 0; right: 0;
}

.email-section {
	.email-section-details {
		margin: 1.5em auto;
		a { margin: 0 0 0 1em; font-weight: bold; }
	}
}
.about-promo-packs {
	.inner {
		max-height: 38em;
		height: 80%;
		max-width: 55em;
		width: 80%;
		.content {
			max-height: 33em;
		}
	}
}

.iframe-wrap {
	width: 100%;
	height: 24em;
	padding: 0;
	border: 1px solid #ccc;
	overflow: hidden;
	iframe {
		width: 135%;
		height: 135%;
		border: 0px;
		zoom: 0.75;
		-moz-transform: scale(0.75);
		-moz-transform-origin: 0 0;
		-o-transform: scale(0.75);
		-o-transform-origin: 0 0;
		-webkit-transform: scale(0.75);
		-webkit-transform-origin: 0 0;
	}
}
</style>
